const de = {
  sinObra: "Ohne Projekt",
  cat: { materiales: "Material", mano_obra: "Arbeitskosten", subcontratas: "Subunternehmer", suministros: "Versorgung", fiscal: "Steuern / Abgaben" },
  rama: {
    albanil_oficial: "Maurer (Facharbeiter)", fontanero: "Installateur", electricista: "Elektriker", carpinteria_madera: "Holzbau / Tischlerei",
    carpintero_aluminio: "Aluminiumbau", gestion_residuos: "Abfallentsorgung", transportes: "Transporte",
    peones: "Hilfsarbeiter / Helfer", gestiones_comerciales: "Vertrieb & Verwaltung",
  },
  exento: { si: "Steuerfrei", marcar: "Als steuerfrei markieren", marcado: "Ausgabe als steuerfrei markiert", quitado: "Markierung «steuerfrei» entfernt", error: "Die Ausgabe konnte nicht aktualisiert werden" },
  toast: {
    subida: "Bild hochgeladen", leyendo: "Bild hochgeladen · Rechnungsdaten werden gelesen…", leidos: "Rechnungsdaten automatisch gelesen ✨",
    noLeidos: "Die Daten konnten nicht automatisch gelesen werden. Bitte von Hand ergänzen.", errorSubir: "Das Bild konnte nicht hochgeladen werden",
    registrado: "Ausgabe gespeichert", eliminado: "Ausgabe gelöscht",
  },
  jornada: {
    titulo: "Arbeitszeit pro Projekt (Grenze {{n}} h/Woche)", totales: "{{n}} h gesamt",
    excesoObras: "{{n}} Projekt(e)", excesoTexto: "überschreiten {{n}} h Arbeit pro Woche. Prüfen Sie die Auslastung.",
    vacio: "Noch keine Arbeitsstunden erfasst. Fügen Sie eine Ausgabe der Kategorie «Arbeitskosten» mit Projekt und Stunden hinzu.",
    semExcedidas: "{{n}} Woche(n) überschritten", resumen: "{{h}} h · {{n}} Woche(n)", excesoSemana: "{{h}} h über der gesetzlichen Grenze von {{n}} h.",
  },
  coste: { titulo: "Kosten pro Projekt", ver: "Projekte ansehen →", obra: "Projekt", materiales: "Material", manoObra: "Arbeitskosten", total: "Gesamtkosten" },
  vacio: { titulo: "Keine Ausgaben", hint: "Erfassen Sie Rechnungen für Material, Arbeit und Subunternehmer" },
  tabla: { concepto: "Beschreibung", categoria: "Kategorie", fecha: "Datum", horas: "Stunden", total: "Gesamt", justificante: "Beleg", justificanteM: "Beleg" },
  form: {
    escanea: "Scannen Sie Ihre Rechnung, wir füllen die Daten aus", quitar: "Bild entfernen", leyendo: "Wird gelesen…", camara: "Mit Kamera scannen",
    subir: "Datei hochladen", analizando: "Bild wird analysiert…",
    ocrBloqueado: "Sie können das Bild anhängen; das automatische Lesen mit KI gibt es ab dem Quartalstarif.",
    concepto: "Beschreibung", categoria: "Kategorie", proveedor: "Lieferant / Firma", base: "Nettobetrag (€)", impuesto: "Steuer",
    obra: "Projekt", irpf: "IRPF-Einbehalt (Freiberufler)", sinRetencion: "Kein Einbehalt",
    isp: "Umkehr der Steuerschuldnerschaft", ispNota: "(Bau-Subunternehmer, der ohne MwSt. oder IGIC abrechnet)",
    exento: "Steuerfrei", exentoNota: "(Versicherungen, Gebühren, Wohnungsmiete…)",
    horas: "Stunden", rama: "Gewerk", datosFactura: "Rechnungsdaten", numero: "Rechnungsnr.", hora: "Uhrzeit des Kaufs",
    nif: "NIF / CIF der Firma", registro: "Handelsregisternr.", opcional: "Optional", fecha: "Datum",
  },
};

export default de;
